import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthLayout, { Field } from "./AuthLayout";
import * as authService from "../services/auth";
import { formatApiErrorDetail } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const { applyAuth } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.login(form.email, form.password);
      applyAuth(data);
      toast.success(`Welcome back, ${data.user.name?.split(" ")[0]}.`);
      navigate("/home");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout eyebrow="Sign in" title="Access workspace"
      footer={<>No account? <Link to="/signup" className="text-white hover:underline" data-testid="login-to-signup">Create one</Link></>}>
      <form onSubmit={submit} data-testid="login-form">
        <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} placeholder="you@email.com" testid="login-email" required />
        <Field label="Password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} placeholder="••••••••" testid="login-password" required />

        <div className="mb-5 flex items-center justify-between">
          <label className="flex cursor-pointer items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="accent-[#d4d8dc]" data-testid="login-remember" />
            Remember me
          </label>
          <button type="button" onClick={() => toast("Password reset is available once backend email is connected.")} className="font-mono text-[10px] uppercase tracking-widest text-neutral-500 hover:text-white" data-testid="login-forgot">
            Forgot?
          </button>
        </div>

        <button type="submit" disabled={loading} className="btn-silver sweep flex w-full items-center justify-center gap-2 rounded-xl px-6 py-3.5 font-mono text-xs font-bold uppercase tracking-widest transition-transform hover:-translate-y-0.5 disabled:opacity-60" data-testid="login-submit-btn">
          {loading ? <Loader2 size={15} className="animate-spin" /> : "Login"}
        </button>
      </form>

    </AuthLayout>
  );
}
